// extracted by mini-css-extract-plugin
module.exports = {"HireSignup":"style_HireSignup__l3fIx","logo":"style_logo__39IfF","welcome":"style_welcome__36E3S","form":"style_form__1TP3A","footer":"style_footer__2hZbO"};